import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    '& .MuiDrawer-paperAnchorRight': {
      maxWidth: 500,
      height: 'calc(100% - 50px)',
      boxShadow: '0px 17px 50px rgba(0, 0, 0, 0.19)',
      background: '#fff',
      padding: 25,
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100% - 50px)',
      },
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
}));
